import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import JobPostingsList from "components/menu/hr/job-postings";
import ApplicantsList from "components/menu/hr/applicants";
import ApplicantView from "components/menu/hr/applicants/view";
import InterviewCategoriesList from "components/menu/hr/interview-categories";
import InterviewQuestionsList from "components/menu/hr/interview-questions";
import ScoringCriteriaManager from "components/menu/hr/scoring-criteria";
import PromptsList from "components/menu/hr/prompts";
import IngestionFailuresList from "components/menu/hr/ingestion-failures";
import IngestionFailureView from "components/menu/hr/ingestion-failures/view";

const HrRouter = props => (
	<div className="px-5">
		<Switch>
			<PrivateRoute exact path={`${props.match.url}/job-postings`} component={JobPostingsList} />
			<PrivateRoute exact path={`${props.match.url}/applicants`} component={ApplicantsList} />
			<PrivateRoute exact path={`${props.match.url}/applicants/:id`} component={ApplicantView} />
			<PrivateRoute exact path={`${props.match.url}/scoring-criteria`} component={ScoringCriteriaManager} />
			<PrivateRoute exact path={`${props.match.url}/interview-categories`} component={InterviewCategoriesList} />
			<PrivateRoute exact path={`${props.match.url}/interview-questions`} component={InterviewQuestionsList} />
			<PrivateRoute exact path={`${props.match.url}/prompts`} component={PromptsList} />
			<PrivateRoute exact path={`${props.match.url}/ingestion-failures`} component={IngestionFailuresList} />
			<PrivateRoute exact path={`${props.match.url}/ingestion-failures/:id`} component={IngestionFailureView} />
		</Switch>
	</div>
);

export default connect()(HrRouter);


